/** @format */

import {
	getRolesAPI,
	deleteRoleAPI,
	expiryNoteDateApi,
	expiryDateApi,
	loginApi,
	searhDateApi,
	postDeleteFileAPI,
} from "../api";
import Instance from "../axois";

const API_URL = process.env.REACT_APP_API;

const getRoles = async (params = { page:0 }) => {
	try {
		const response = await Instance.get(API_URL + getRolesAPI, { params });
		return response.data;
	} catch (error) {
		throw error;
	}
};

const postLoginAuth = async (data) => {
	try {
		  const response = await Instance.post(API_URL + loginApi , data);
		  return response.data;
	  } catch (error) {
		  throw error;
	  }
  };

  const postDate = async (id,data) => {
	try {
		  const response = await Instance.post(API_URL + expiryDateApi +"/"+ id, data);
		  return response.data;
	  } catch (error) {
		  throw error;
	  }
  };

  const viewNoteDate = async (id) => {
	try {
		  const response = await Instance.get(API_URL + expiryNoteDateApi +"/"+ id);
		  return response.data;
	  } catch (error) {
		  throw error;
	  }
  };

const deleteFile = async (id,data) => {
	try {
		const response = await Instance.post(API_URL + postDeleteFileAPI +"/"+ id, data);
		return response;
	} catch (error) {
		throw error;
	}
};

const getSearchFilter = async (data) => {
	try {
		const response = await Instance.get(API_URL + searhDateApi + "/" + data);
		return response;
	} catch (error) {
		throw error;
	}
};


const deleteRole = async (id) => {
	try {
		const response = await Instance.get(API_URL + deleteRoleAPI + "/" + id);
		return response;
	} catch (error) {
		throw error;
	}
};



export {
	deleteRole,
	getRoles,
	getSearchFilter,
	postLoginAuth,
	postDate,
	viewNoteDate,
	deleteFile
};
